import React from 'react'
import { UnknownProps } from 'react-spring'

import clsx from 'clsx'

import { Button } from '@insquad/tools'

import { Input } from 'src/common/components/_form/Input/Input'
import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { useAuthRedirect } from 'src/common/hooks/useAuthRedirect'
import { AnalyticEventEnum } from 'src/utils/analytic/analyticEventEnum'
import { useAnalytic } from 'src/utils/analytic/useAnalytic'

import s from './AboutSignupBlock.module.scss'

export const AboutSignupBlock: React.FC<UnknownProps> = () => {
  const { analytic } = useAnalytic()
  const { handleSubmitHireNow } = useAuthRedirect()

  const handleSignUp = (e: React.FormEvent<HTMLFormElement>) => {
    analytic.event(AnalyticEventEnum.SIGN_UP, {
      page: 'about',
      from: 'input-bottom',
    })

    handleSubmitHireNow(e)
  }

  return (
    <ContentSection className={clsx(s.AboutSignupBlock, 'container')}>
      <Typography
        className={s.AboutSignupBlock__title}
        variant={EnumTypographyVariants.H3}
        text="Sign up to explore thousands of talented pre-vetted startup developers"
      />

      <form onSubmit={handleSignUp} className={s.AboutSignupBlock__form}>
        <Input
          className={s.AboutSignupBlock__input}
          placeholder="Enter your e-mail"
          type="email"
        />
        <Button className={s.AboutSignupBlock__btn}>Hire now</Button>
      </form>
    </ContentSection>
  )
}
